module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10202.a2a079e5.jpg";